/* eslint-disable import/no-default-export */
export default {
  initMemberInfo(state, action) {
    state.consumeScoreMonth = action.consumeScoreMonth
    state.produceScoreMonth = action.produceScoreMonth
    state.score = action.totalScore
    state.gradeInfo = action.grade
    state.ruleUrl = action.ruleUrl
  },
  updateScore(state, data) {
    state.score = data
  }
}
